// extracted by mini-css-extract-plugin
export default {"container":"wan6VNiuhvDEAXGgJwpu","productCard":"DBKGdeavmWliotfZyUHe","processingCard":"BswNXNCus2I2ODPSe_u9"};